var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatistikUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.290039,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#2EC4B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 21.3418C19.745 21.3418 21.25 19.8368 21.25 17.8418C21.25 15.8468 19.745 14.3418 17.75 14.3418C15.755 14.3418 14.25 15.8468 14.25 17.8418C14.25 19.8368 15.755 21.3418 17.75 21.3418ZM18.75 22.2898H16.75C13.993 22.2898 11.75 24.5328 11.75 27.2898V28.2898H23.75V27.2898C23.75 24.5328 21.507 22.2898 18.75 22.2898ZM30.044 17.5818L25.744 21.8738L24.452 20.5818L23.038 21.9958L25.744 24.6998L31.456 18.9978L30.044 17.5818Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistikUser);
export default __webpack_public_path__ + "static/media/StatistikUser.53be3717866179130329c3c6a551e031.svg";
export { ForwardRef as ReactComponent };